import { CircularProgress } from '@material-ui/core';
import React from 'react';
import './index.scss';

function CenteredSpinner(props) {
  return (
    <div className="centered-spinner">
      <CircularProgress />
    </div>
  );
}

export default CenteredSpinner;



// WEBPACK FOOTER //
// ./src/components/Utility/CenteredSpinner/CenteredSpinner.jsx